import {
    BlotterFilteredOrdersState,
    initialBlotterFilteredOrdersState,
} from './filteredOrders/BlotterFilteredOrdersState';
import {
    BlotterComponentState,
    initialBlotterComponentState,
} from './components/BlotterComponentsState';
import {
    BlotterConfiguration,
    initialBlotterConfiguration,
} from './configuration/BlotterConfiguration';
import { WidgetWithConfigState } from 'widgets/store/configuration/WidgetWithConfigState';
import { WidgetWithComponentState } from 'widgets/store/component/WidgetWithComponentState';

export interface BlotterWidgetState
    extends WidgetWithConfigState<BlotterConfiguration>,
        WidgetWithComponentState<BlotterComponentState> {
    filteredOrders: BlotterFilteredOrdersState;
}

export interface BlotterWidgetsState {
    [widgetId: string]: BlotterWidgetState;
}

export const initialBlotterWidgetState: BlotterWidgetState = {
    config: initialBlotterConfiguration,
    component: initialBlotterComponentState,
    filteredOrders: initialBlotterFilteredOrdersState,
};

export const initialBlotterWidgetsState: BlotterWidgetsState = {};
